import { delay } from "../../utils"
import { rest } from "msw"

export const language = [
  rest.get("*/v1/version/", function (_req, res, ctx) {
    return res(delay(ctx), ctx.json(require("./fixture.json")))
  }),
]
